<div class="d-flex gap-2 mb-2 secondary-text">
  <rs-web-icon [icon]="immomioIconName.Calendar" [size]="16"></rs-web-icon>
  <div>{{ ticketDetails.created | date: 'EEEEEE dd.MM.yyyy' }}</div>
</div>

@if (ticketDetails.formResponses.length > 0 || ticketDetails.categoryResponses.length > 0) {
  <div class="mb-3 h4 primary-text">{{ 'damage.damage_details' | translate }}</div>
  <div>
    @if (ticketDetails.categoryResponses.length > 0) {
      @for (response of ticketDetails.categoryResponses; track response.index) {
        <div class="mb-2">
          <rs-web-label [text]="response.questionText" className="secondary-text"></rs-web-label>
        </div>
        <div class="mb-2 primary-text">{{ response.response }}</div>
      }
    }
    @if (ticketDetails.formResponses.length > 0) {
      <hr class="my-3" />
      @for (
        response of ticketDetails.formResponses.slice(0, shownAnswersCount);
        track response.index
      ) {
        <div class="mb-2">
          <rs-web-label [text]="response.questionText" className="secondary-text"></rs-web-label>
        </div>
        @switch (response.type) {
          @case (formResponseQuestionType.TEXTBOX) {
            <p class="mb-2 primary-text" [innerHTML]="response.responses[0] | defaultValue"></p>
          }
          @case (formResponseQuestionType.TEXTFIELD) {
            <p class="mb-2 primary-text" [innerHTML]="response.responses[0] | defaultValue"></p>
          }
          @case (formResponseQuestionType.NUMBERFIELD) {
            <p class="mb-2 primary-text" [innerHTML]="response.responses[0] | defaultValue"></p>
          }
          @case (formResponseQuestionType.DATE) {
            <div class="mb-2 primary-text">
              {{ response.responses[0] | date: 'EEEEEE dd.MM.yyyy' | defaultValue }}
            </div>
          }
          @case (formResponseQuestionType.ATTACHMENTS) {
            @if (response.attachments?.length > 0) {
              @let nonPdfAttachments =
                response.attachments.filter(attachment => attachment.extension !== 'pdf');
              @let pdfAttachments =
                response.attachments.filter(attachment => attachment.extension === 'pdf');

              <!-- Images -->
              @if (nonPdfAttachments.length > 0) {
                <div class="row gy-4 mb-2">
                  @for (s3File of nonPdfAttachments; track s3File.identifier) {
                    <div class="col-4">
                      <rs-web-ticket-image-viewer
                        (click)="
                          openFilePreview(ticketDetails.id, response.attachments, s3File.identifier)
                        "
                        (attachmentLoaded)="onAttachmentLoaded($event)"
                        [ticketId]="ticketDetails.id"
                        [attachmentIdentifier]="s3File.identifier"
                      ></rs-web-ticket-image-viewer>
                    </div>
                  }
                </div>
              }

              <!-- PDFs -->
              @if (pdfAttachments.length > 0) {
                <div class="row gy-4 mb-2">
                  <div class="d-flex flex-column">
                    @for (s3File of pdfAttachments; track s3File.identifier) {
                      <rs-web-pdf-attachment
                        (click)="
                          openFilePreview(ticketDetails.id, response.attachments, s3File.identifier)
                        "
                        role="button"
                        [s3File]="s3File"
                        [isRemovable]="false"
                      >
                      </rs-web-pdf-attachment>
                    }
                  </div>
                </div>
              }
            } @else {
              {{ '-' }}
            }
          }
          @case (formResponseQuestionType.SELECTION) {
            <div class="mb-2 primary-text">
              {{ response.responses[0] | defaultValue }}
            </div>
          }
          @case (formResponseQuestionType.MULTISELECT) {
            <div class="mb-2 primary-text">
              @for (value of response.responses; track value; let last = $last) {
                {{ value | defaultValue }}{{ !last ? ', ' : '' }}
              }
            </div>
          }
        }
      }
    }
  </div>
}
@if (showMoreButton) {
  <div class="d-flex">
    <button im-button class="inverted" (click)="showMore()">
      {{ ('general.show_more_b' | translate) + ' +' }}
    </button>
  </div>
}
